import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import PagingGrid, {defaultPageSize, processPagingParams} from '../fw/PagingGrid.react';
import AppPanel from '../fw/AppPanel.react';
import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {renderProgress} from './JobView.react';
import RefreshButton from './RefreshButton.react';
import * as Tool from '../fw/Tool';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'jobList.title', 'defaultMessage': 'Jobs'}
});

interface ChannelJobListProps {
    intl: IntlShape;
    relay?: object;
    user: User;
}

class ChannelJobList extends React.Component<ChannelJobListProps> {

    typeName = 'jobs';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired
    };

    getUrl = (item, column) => {
        if (column) {
            return;
        }

        return urlMapping.getUrl(types[this.typeName], 'view', {
            id: item.id,
            organisation_id: this.props.user.organisation['realId']
        });
    };


    render() {
        let { user } = this.props;
        let list = user.organisation.channel.jobs;
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type: types['channels'], data: this.props.user.organisation.channel},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <div className="btn-toolbar" role="toolbar">
                    <RefreshButton autoRefresh relay={this.props.relay} />
                </div>

                <PagingGrid
                        columns={{
                            'name': {
								// eslint-disable-next-line max-params
                                render: (column, item, url, columnMapping) => {
                                    let value = Tool.getFormatted(type, 'name', this.props.intl.formatMessage, item);

                                    if (value) {
                                        return value;
                                    } else {
                                        return Tool.getFormatted(type, 'type', this.props.intl.formatMessage, item);
                                    }
                                }
                            },
                            'createdAt': {},
                            'stop': {},
                            'status': {
								// eslint-disable-next-line max-params
                                render: (column, item, url, columnMapping) => {
                                    return renderProgress(type, item, this.props.intl.formatMessage);
                                }
                            }
                        }}
                        edges={list}
                        getUrl={this.getUrl}
                        linkOnlyOnField={["name"]}
                        metadata={type}
                        pageInfo={list.pageInfo}
                        relay={this.props.relay}
                        urlMapping={urlMapping}
                    />
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(ChannelJobList), (props) => {
    return props.user.organisation;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        first: defaultPageSize,
        after: null,
        before: null,
        last: null,
    },
    prepareVariables (variables) {
        processPagingParams(variables);

		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    channel(id: $channelId) {
                        id,
                        realId,
                        jobs(first: $first, after: $after, before: $before, last: $last) {
                            edges {
                                node {
                                    id,
                                    organisation_id,
                                    type,
                                    name,
                                    status,
                                    createdAt,
                                    progress,
                                    start,
                                    stop,
                                }
                            },
                            pageInfo {
                                hasNextPage,
                                hasPreviousPage,
                                startCursor,
                                endCursor
                            }
                        }
                    }
                }
            }
        `,
    },
});
